import { createFileRoute } from "@tanstack/react-router"
import { MFAMethodPage } from "@/pages/MFAMethodPage"

export const Route = createFileRoute(
  "/_authenticated/_account/account-settings/security/mfa-method"
)({
  component: MFAMethodPage,
})
